import type { CustomFieldSignature } from '../../types/tuition-assistance.ts';
import { formatAsDollars } from '../format.ts';

/**
 * Resolves option labels and formats currency values whose persisted unit is cents.
 */
export const formatReadonlyCustomFieldValue = (
  value: string | boolean | number | null | undefined,
  field: CustomFieldSignature
): string | boolean | number | null | undefined => {
  const option = field.options.find(
    (candidate) =>
      candidate.value === value ||
      (candidate.value !== null &&
        candidate.value !== undefined &&
        value !== null &&
        value !== undefined &&
        String(candidate.value).toLowerCase() === String(value).toLowerCase())
  );
  if (option) return option.label;

  const isBlank =
    value === null || value === undefined || (typeof value === 'string' && value.trim() === '');

  if (field.inputType === 'currency' && !isBlank) {
    const cents = Number(value);
    if (!Number.isNaN(cents)) return formatAsDollars(cents);
  }

  return value;
};
